/**
 * Impressao + PDF do romaneio — mesma tecnica do legado RevisorFerragens.
 *
 * `imprimirAgora` abre uma JANELA limpa (sem sidebar/topbar do app) com apenas
 * o documento, garantindo que a impressao saia so com a folha. `baixarPdf`
 * captura cada `.rmn-paper` (html2canvas) e monta um A4 multi-pagina (jsPDF),
 * gerando um arquivo de verdade. Sem CDN — usa as libs que o ERP ja tem.
 */

import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

import { documentoCssJanela } from "./documentoCss";

const SELETOR_FOLHAS = "#romaneio-print-papers .rmn-paper";

export function imprimirAgora() {
  const node = document.getElementById("romaneio-print-papers");
  if (!node) {
    window.print();
    return;
  }
  const win = window.open("", "_blank", "width=920,height=1040");
  if (!win) {
    window.print();
    return;
  }
  win.document.open();
  win.document.write(
    '<!DOCTYPE html><html lang="pt-br"><head><meta charset="utf-8">' +
    "<title>Romaneio de carregamento</title>" +
    `<style>${documentoCssJanela()}</style>` +
    `</head><body>${node.outerHTML}</body></html>`,
  );
  win.document.close();
  win.focus();
  setTimeout(() => {
    try {
      win.print();
    } catch {
      /* usuario pode imprimir manualmente */
    }
  }, 350);
}

export async function baixarPdf(filename = "Romaneio.pdf") {
  const papers = Array.from(document.querySelectorAll(SELETOR_FOLHAS));
  if (!papers.length) return;

  const pdf = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait", compress: true });
  const pageW = 210;
  const pageH = 297;

  for (let i = 0; i < papers.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    const canvas = await html2canvas(papers[i], {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
    });

    if (i > 0) pdf.addPage();

    const imgData = canvas.toDataURL("image/jpeg", 0.95);
    const imgW = pageW;
    const imgH = (canvas.height / canvas.width) * imgW;

    if (imgH <= pageH + 1) {
      pdf.addImage(imgData, "JPEG", 0, 0, imgW, imgH);
    } else {
      let y = 0;
      let primeira = true;
      while (y < imgH) {
        if (!primeira) pdf.addPage();
        pdf.addImage(imgData, "JPEG", 0, -y, imgW, imgH);
        y += pageH;
        primeira = false;
      }
    }
  }

  pdf.save(filename);
}
